import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api, { imgUrl } from "@/lib/api";

const TABS = ["All", "Rooms", "Lobby & Reception", "Neighborhood"];

export const Gallery = () => {
  const [tab, setTab] = useState("All");
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    api.get("/gallery").then(({ data }) => setPhotos(data)).catch(() => {});
  }, []);

  const items = tab === "All" ? photos : photos.filter((g) => g.category === tab);

  return (
    <section id="gallery" className="py-16 lg:py-24 bg-muted/40">
      <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
        <span className="text-sm font-semibold uppercase tracking-[0.15em] text-primary">Visual Tour</span>
        <h2 className="mt-2 font-serif text-3xl sm:text-4xl font-semibold">A Glimpse of Your Stay</h2>

        <div className="mt-6 flex flex-wrap gap-2">
          {TABS.map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              data-testid={`gallery-tab-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                tab === t ? "bg-primary text-primary-foreground shadow" : "bg-card border border-border hover:border-primary/40"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-3 lg:gap-4" data-testid="gallery-grid">
          {items.map((img, i) => (
            <motion.div
              key={img.id || img.url}
              layout
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className={`group relative overflow-hidden rounded-xl ${i % 5 === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
            >
              <img src={imgUrl(img.url)} alt={img.title}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${i % 5 === 0 ? "h-full min-h-[220px]" : "h-44 lg:h-52"}`} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                <span className="text-white text-sm font-medium">{img.title}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
